import React from "react";
import Modal from "react-modal";
import Nav from "./Nav";
import Spinner from "./Spinner";
import Sidebar from "./Sidebar";
import Paginador from "./Paginador";
import { useNavContext } from "../context/NavContext";
import { useNumeroConfig } from "../hooks/useNumeroConfig";
import { useListaTodos } from "../hooks/useListaTodos";
import ContactDetailModal from "./ContactDetailModal";

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    paddingLeft: 0,
    padding: 0,
    fontFamily: "Roboto, sans-serif",
    "::WebkitScrollbar": { width: "0px", background: "transparent" },
    msOverflowStyle: "none",
    scrollbarWidth: "none",
  },
  label: {
    display: "block",
    width: "160px",
    textAlign: "right",
    whiteSpace: "nowrap",
  },
  input: {
    width: "100%",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)", zIndex: 101 },
};

const stepContainerStyle = {
  display: "flex",
  justifyContent: "left",
  marginLeft: "100px",
  gap: "50px",
  marginBottom: "20px",
  cursor: "pointer",
};

const stepStyle = (isActive) => ({
  padding: "10px 15px",
  borderBottom: isActive ? "4px solid #007bff" : "4px solid transparent",
  transition: "border-bottom 0.3s ease",
  fontWeight: isActive ? "bold" : "normal",
});

const ListaTodos = () => {
  const {
    numero: numeroContactoAuto,
    modo: modoNumeroContacto,
    abrirConfiguracion: abrirConfigContacto,
    NumeroConfigModalUI: NumeroConfigModalContactoUI,
  } = useNumeroConfig("numeroContacto", {
    title: "Configurar id del contacto",
  });

  const { searchTerm, proximasAVencer, proximosEventos } = useNavContext();

  const {
    // estado base
    isLoading,
    formData,
    setFormData,
    modalIsOpen,
    setModalIsOpen,
    step,
    setStep,
    editingRef,
    // búsqueda y sort
    searchQuery,
    setSearchQuery,
    sortBy,
    sortOrder,
    handleSort,
    // lista derivada
    sortedContacts,
    // acciones
    handleOpenModal,
    handleChange,
    handleEdit,
    handleDelete,
    handleSubmit,
  } = useListaTodos({ modoNumeroContacto });

  // === Paginación (mismo patrón que en Generador) ===
  const [itemsPerPage, setItemsPerPage] = React.useState(25);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [detailOpen, setDetailOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = React.useState(null);
  const openDetail = (row) => {
    setSelectedRow(row);
    setDetailOpen(true);
  };
  const closeDetail = () => {
    setDetailOpen(false);
    setSelectedRow(null);
  };

  const totalContacts = sortedContacts.length;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedContacts = React.useMemo(
    () => sortedContacts.slice(startIndex, endIndex),
    [sortedContacts, startIndex, endIndex]
  );

  const handleItemsPerPageChange = (items) => setItemsPerPage(items);
  const handlePageChange = (page) => setCurrentPage(page);

  // Resetea a página 1 cuando cambie búsqueda u orden
  React.useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, sortBy, sortOrder]);

  const showNuevoButton = true;

  const tituloPaso1 = editingRef
    ? formData.tipo === "Proveedor"
      ? "Actualizar Proveedor"
      : "Actualizar Cliente"
    : "Agrega los datos";

  const textoBotonSubmit = editingRef
    ? formData.tipo === "Proveedor"
      ? "Actualizar Proveedor"
      : "Actualizar Cliente"
    : "Agregar";

  return (
    <>
      <Nav
        handleSearch={searchTerm}
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />

      <div className="task-filters">
        <div className="header-actions-proyectos">
          <button className="action-button-proyectos">
            <i className="bi bi-funnel-fill"></i> Todos
            <i className="bi bi-chevron-down" style={{ fontSize: "12px" }}></i>
          </button>

          <div className="buscador-pedidos">
            <i className="bi bi-search"></i>
            <input
              type="text"
              className="buscador-input"
              placeholder="Buscar contactos"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="task-filters-right">
          <div
            className="view-buttons-container"
            style={{ position: "relative" }}
          >
            <button className="view-button">
              <i className="bi bi-three-dots-vertical"></i>
            </button>
            <button className="exportar-button">
              <i className="bi bi-cloud-arrow-down"></i> Exportar
            </button>
            {showNuevoButton && (
              <button className="new-task-button" onClick={handleOpenModal}>
                + Nuevo
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="cotizaciones-table">
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={() => setModalIsOpen(false)}
              style={customStyles}
            >
              <div>
                <button
                  className="cerrar-button"
                  onClick={() => setModalIsOpen(false)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>

              <Nav
                handleSearch={searchTerm}
                proximasAVencer={proximasAVencer}
                proximosEventos={proximosEventos}
              />

              <Sidebar />

              {step === 1 && (
                <>
                  <h2 style={{ textAlign: "left", marginLeft: "100px" }}>
                    {tituloPaso1}
                  </h2>

                  <div style={stepContainerStyle}>
                    <div
                      style={stepStyle(step === 1)}
                      onClick={() => setStep(1)}
                    >
                      Info
                    </div>
                    <div
                      style={stepStyle(step === 2)}
                      onClick={() => setStep(2)}
                    >
                      Dirección
                    </div>
                  </div>

                  <form
                    onSubmit={(e) => handleSubmit(e, modoNumeroContacto)}
                    className="client-form"
                  >
                    {/* FILA: ID autogenerado con icono */}
                    <div className="form-row">
                      <label style={customStyles.label}>ID</label>
                      <div style={{ position: "relative", width: "100%" }}>
                        <input
                          type="text"
                          name="id"
                          value={
                            formData.id !== "" && formData.id !== null
                              ? formData.id
                              : numeroContactoAuto
                          }
                          onChange={(e) => {
                            if (modoNumeroContacto === "manual") {
                              setFormData((prev) => ({
                                ...prev,
                                id: e.target.value,
                              }));
                            }
                          }}
                          disabled={modoNumeroContacto === "auto"}
                          style={{
                            ...customStyles.input,
                            paddingRight: "48px",
                          }}
                        />
                        <button
                          type="button"
                          onClick={abrirConfigContacto}
                          title="Configurar ID"
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                            padding: 0,
                          }}
                        >
                          <i
                            className="bi bi-gear-fill"
                            style={{ fontSize: 18, color: "#0d6efd" }}
                          />
                        </button>
                      </div>
                    </div>

                    {/* FILA: Tipo + Empresa */}
                    <div className="form-row">
                      <label style={customStyles.label}>Tipo:</label>
                      <select
                        style={customStyles.select}
                        name="tipo"
                        value={formData.tipo}
                        onChange={handleChange}
                      >
                        <option value="Cliente">Cliente</option>
                        <option value="Proveedor">Proveedor</option>
                        <option value="Ambos">Ambos</option>
                      </select>

                      <label className="required" style={customStyles.label}>
                        Nombre de la Empresa*
                      </label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="empresa"
                        placeholder="Nombre de la Empresa"
                        value={formData.empresa}
                        onChange={handleChange}
                      />
                    </div>

                    {/* FILA: RFC + Régimen Fiscal */}
                    <div className="form-row">
                      <label style={customStyles.label}>RFC</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="rfc"
                        placeholder="RFC"
                        value={formData.rfc}
                        onChange={handleChange}
                      />

                      <label style={customStyles.label}>Régimen Fiscal</label>
                      <select
                        style={customStyles.select}
                        id="regimen"
                        name="regimenFiscal"
                        value={formData.regimenFiscal}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Seleccione un régimen fiscal
                        </option>
                        <option value="601">
                          601 - General de Ley Personas Morales
                        </option>
                        <option value="612">
                          612 - Personas Físicas con Actividades Empresariales y
                          Profesionales
                        </option>
                        <option value="616">
                          616 - Sin obligaciones fiscales
                        </option>
                        <option value="626">
                          626 - Régimen Simplificado de Confianza (RESICO)
                        </option>
                      </select>
                    </div>

                    {/* FILA: Moneda + Teléfono */}
                    <div className="form-row">
                      <label style={customStyles.label}>Moneda</label>
                      <select
                        style={customStyles.select}
                        id="moneda"
                        name="moneda"
                        value={formData.moneda}
                        onChange={handleChange}
                      >
                        <option value="" disabled>
                          Seleccione una moneda
                        </option>
                        <option value="MXN">MXN</option>
                        <option value="USD">USD</option>
                      </select>

                      <label style={customStyles.label}>Teléfono</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="telefono"
                        placeholder="Teléfono"
                        value={formData.telefono}
                        onChange={handleChange}
                      />
                    </div>

                    {/* FILA: Condiciones de pago + Fecha de alta */}
                    <div className="form-row">
                      <label style={customStyles.label}>Cond. de pago</label>
                      <select
                        style={customStyles.select}
                        name="condicionesPago"
                        value={formData.condicionesPago}
                        onChange={handleChange}
                      >
                        <option value="">Seleccione</option>
                        <option value="Contado">Contado</option>
                        <option value="Crédito 7 días">Crédito 7 días</option>
                        <option value="Crédito 15 días">Crédito 15 días</option>
                        <option value="Crédito 30 días">Crédito 30 días</option>
                        <option value="Crédito 45 días">Crédito 45 días</option>
                        <option value="Crédito 60 días">Crédito 60 días</option>

                        {/* Si el valor actual es personalizado, muéstralo como opción */}
                        {formData.condicionesPago &&
                          ![
                            "Contado",
                            "Crédito 7 días",
                            "Crédito 15 días",
                            "Crédito 30 días",
                            "Crédito 45 días",
                            "Crédito 60 días",
                          ].includes(formData.condicionesPago) && (
                            <option value={formData.condicionesPago}>
                              {formData.condicionesPago}
                            </option>
                          )}

                        {/* Opción para agregar una condición personalizada */}
                        <option value="__add__">
                          + Agregar condición de pago…
                        </option>
                      </select>

                      <label style={customStyles.label}>Fecha de alta</label>
                      <input
                        style={customStyles.input}
                        type="date"
                        name="fechaAlta"
                        value={formData.fechaAlta || ""}
                        onChange={handleChange}
                      />
                    </div>

                    {/* FILA: Email + Imagen */}
                    <div className="form-row">
                      <label style={customStyles.label}>Email</label>
                      <input
                        style={customStyles.input}
                        type="email"
                        name="correo"
                        placeholder="Correo Electrónico"
                        value={formData.correo}
                        onChange={handleChange}
                      />

                      <label style={customStyles.label}>Imagen</label>
                      <input
                        style={{
                          width: "100%",
                          display: "block",
                          padding: "8px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          boxSizing: "border-box",
                        }}
                        type="file"
                        name="imagen"
                        onChange={handleChange}
                      />
                    </div>
                  </form>
                </>
              )}

              {step === 2 && (
                <>
                  <h2 style={{ textAlign: "left", marginLeft: "100px" }}>
                    Agrega los últimos datos
                  </h2>

                  <div style={stepContainerStyle}>
                    <div
                      style={stepStyle(step === 1)}
                      onClick={() => setStep(1)}
                    >
                      Info
                    </div>
                    <div
                      style={stepStyle(step === 2)}
                      onClick={() => setStep(2)}
                    >
                      Dirección
                    </div>
                  </div>

                  <form
                    onSubmit={(e) => handleSubmit(e, modoNumeroContacto)}
                    className="client-form"
                  >
                    <div className="form-row">
                      <label style={customStyles.label}>Domicilio</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="domicilio"
                        placeholder="Domicilio"
                        value={formData.domicilio}
                        onChange={handleChange}
                      />
                      <label style={customStyles.label}>No. Exterior</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="numeroExt"
                        placeholder="No. Ext"
                        value={formData.numeroExt}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-row">
                      <label style={customStyles.label}>No. Interior</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="numeroInt"
                        placeholder="No. Int"
                        value={formData.numeroInt}
                        onChange={handleChange}
                      />
                      <label style={customStyles.label}>Colonia</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="colonia"
                        placeholder="Colonia"
                        value={formData.colonia}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-row">
                      <label style={customStyles.label}>Código Postal</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="codigoPostal"
                        placeholder="C.P."
                        value={formData.codigoPostal}
                        onChange={handleChange}
                      />
                      <label style={customStyles.label}>Ciudad</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="ciudad"
                        placeholder="Ciudad"
                        value={formData.ciudad}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-row">
                      <label style={customStyles.label}>Estado</label>
                      <input
                        style={customStyles.input}
                        type="text"
                        name="estado"
                        placeholder="Estado"
                        value={formData.estado}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-toolbar">
                      <div className="leftBtn">
                        <button
                          id="guardar-enviar"
                          className="btn btn-primary"
                          type="submit"
                        >
                          {textoBotonSubmit}
                        </button>
                        <button
                          id="cancelar"
                          className="btn btn-secondary"
                          type="button"
                          onClick={() => setModalIsOpen(false)}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              )}

              <NumeroConfigModalContactoUI />
            </Modal>
            <ContactDetailModal
              isOpen={detailOpen}
              onClose={closeDetail}
              data={selectedRow}
              onEdit={
                selectedRow
                  ? () => {
                      closeDetail();
                      handleEdit(selectedRow.docId, selectedRow.tipo);
                    }
                  : undefined
              }
            />

            {/* === Wrapper + Content para alinear con estilos de Generador === */}
            <div className="tabla-cotizaciones-wrapper">
              <div className="tabla-cotizaciones-content">
                {paginatedContacts.length > 0 ? (
                  <table>
                    <thead>
                      <tr>
                        <th onClick={() => handleSort("id")}>
                          ID{" "}
                          {sortBy === "id"
                            ? sortOrder === "asc"
                              ? "↑"
                              : "↓"
                            : null}
                        </th>
                        <th onClick={() => handleSort("tipo")}>
                          Tipo{" "}
                          {sortBy === "tipo"
                            ? sortOrder === "asc"
                              ? "↑"
                              : "↓"
                            : null}
                        </th>
                        <th onClick={() => handleSort("empresa")}>
                          Nombre{" "}
                          {sortBy === "empresa"
                            ? sortOrder === "asc"
                              ? "↑"
                              : "↓"
                            : null}
                        </th>
                        <th onClick={() => handleSort("telefono")}>
                          Teléfono{" "}
                          {sortBy === "telefono"
                            ? sortOrder === "asc"
                              ? "↑"
                              : "↓"
                            : null}
                        </th>
                        <th onClick={() => handleSort("condicionesPago")}>
                          Cond. de pago{" "}
                          {sortBy === "condicionesPago"
                            ? sortOrder === "asc"
                              ? "↑"
                              : "↓"
                            : null}
                        </th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedContacts.map((item) => (
                        <tr
                          key={item.docId}
                          onClick={() => openDetail(item)}
                          style={{ cursor: "pointer" }}
                        >
                          <td style={{ width: "10%" }}>{item.id || "-"}</td>
                          <td style={{ width: "10%" }}>{item.tipo}</td>
                          <td style={{ width: "25%" }}>{item.empresa}</td>
                          <td>{item.telefono}</td>
                          <td>{item.condicionesPago || "—"}</td>
                          <td
                            style={{
                              width: 80,
                              textAlign: "center",
                              padding: "4px 2px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <i
                              className="bi bi-pencil-fill"
                              style={{ cursor: "pointer", marginRight: 8 }}
                              title="Editar"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEdit(item.docId, item.tipo);
                              }}
                            />
                            <i
                              className="bi bi-trash-fill"
                              style={{ cursor: "pointer", color: "#dc3545" }}
                              title="Eliminar"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(item.docId, item.tipo);
                              }}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-resultados">
                    <div
                      className="mensaje-sin-resultados"
                      style={{ marginTop: "30px" }}
                    >
                      <p style={{ fontSize: "14px" }}>
                        {totalContacts === 0
                          ? "No existe ningún contacto que coincida con esta búsqueda."
                          : "No hay contactos en esta página."}
                      </p>
                    </div>
                    <div className="imagen-sin-resultados">
                      <img
                        src="/img/noSearch.svg"
                        alt="Sin resultados"
                        className="sin-resultados-imagen"
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* === Footer con Paginador (idéntico a Generador) === */}
              <div className="tabla-cotizaciones-footer">
                <div className="paginador-container">
                  <Paginador
                    totalItems={totalContacts}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    onItemsPerPageChange={handleItemsPerPageChange}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ListaTodos;
